import { render, staticRenderFns } from "./SettingsLanguage.vue?vue&type=template&id=fb724862&scoped=true&"
import script from "./SettingsLanguage.vue?vue&type=script&lang=js&"
export * from "./SettingsLanguage.vue?vue&type=script&lang=js&"
import style0 from "./SettingsLanguage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SettingsLanguage.vue?vue&type=style&index=1&id=fb724862&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb724862",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
